import { QueryClient } from "@tanstack/react-query";
import { SURVEY_QUERIES } from "~/shared/api/surveys/surveys.queries";

export function surveysViewLoader(queryClient: QueryClient) {
  queryClient.prefetchQuery(
    SURVEY_QUERIES.list({
      params: {
        limit: 50,
        skip: 0,
      },
    }),
  );

  return null;
}
